'use strict';

exports.__esModule = true;
exports.getLink = getLink;

var _TagTypes = require('../../types/TagTypes');

function getLink(context, name, rel) {
  if (context[name]) {
    return [{
      type: _TagTypes.TAG_TYPES.LINK,
      props: {
        rel: rel,
        href: context[name]
      }
    }];
  }
  return [];
}